import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import GridTable from "../../../Components/CommonTable/GridTable/GridTable";

import { UsersApi } from "../../../App/api/users.api.js";
import MenuApi from "../../../App/api/menu.apis.js";
import { useFetchAll } from "../../../custom/FetchApiHook.jsx";

import filters from "./Filters.js";
import UsersModal from "../../../Components/Modals/UsersModal/UsersModal.jsx";

const Users = () => {
  const [gridToggle, SetGridToggle] = useState(false);
  const [toggleUsersDetails, setToggleUsersDetails] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const debounceTimeout = useRef();

  const [search, setSearch] = useState("");

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    sortOrder: "desc",
    filter: {},
  });

  const countryOptions = useSelector((state) =>
    state.country.data.map((d) => ({
      name: d.name,
      code: d._id,
    }))
  );

  const { value, fetchAllData } = useFetchAll(() =>
    UsersApi.getAllCustomer(pagination, search)
  );

  // ---------------- Fetch Cities ----------------
  const getCity = async () => {
    try {
      const res = await MenuApi.getAllCity(pagination.filter.country);

      filterConfig.filters[2].options = res.data.data.map((d) => ({
        name: d.name,
        code: d._id,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (pagination.filter?.country) {
      getCity();
    }
  }, [pagination.filter?.country]);

  // ---------------- Pagination ----------------
  const handlePagination = (data) => {
    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let updatedFilter = { ...prev.filter };

      if (data.filter) {
        updatedFilter = {
          ...updatedFilter,
          ...data.filter,
        };
      }

      return {
        page: data.page || prev.page,
        limit: data.limit || prev.limit,
        sortOrder: data.sortOrder || prev.sortOrder,
        filter: updatedFilter,
      };
    });
  };

  // ---------------- Search ----------------
  const handleSearch = useCallback((value) => {
    setSearch(value);
  }, []);

  const debouncedSearch = useCallback(
    (value) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        handleSearch(value);
      }, 1500);
    },
    [handleSearch]
  );

  // ---------------- Filters ----------------
  const handleFilter = (name, value) => {
    let data = {};

    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      data.filter = {
        [name]: value.code ?? value,
      };
    }

    handlePagination(data);
  };

  const handleClearFilter = () => {
    handlePagination({
      clearPagination: {
        page: 1,
        limit: 10,
        sortOrder: "desc",
        filter: {},
      },
    });

    setSearch("");
  };

  // ---------------- Filter Config ----------------
  const filterConfig = {
    ...filters,
    filters: [...filters.filters],
    handleSearch: debouncedSearch,
    handleFilter,
    handleClearFilter,
  };

  filterConfig.filters[1] = {
    ...filterConfig.filters[1],
    options: countryOptions,
  };

  // ---------------- Fetch Data ----------------
  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  return (
    <>
      <div className="pt-5">
        <CommonLayout />
      </div>

      <div style={{ paddingBottom: "4rem" }}>
        <div style={{ paddingBottom: "2rem" }}>
          <GridTable
            FilterData={filterConfig}
            handlePagination={handlePagination}
            isGrid={gridToggle}
            SetGridToggle={SetGridToggle}
            type="users"
            value={value}
            setSelectedData={setSelectedData}
            setToggleUsersDetails={setToggleUsersDetails}
          />
        </div>
      </div>

      {toggleUsersDetails && (
        <UsersModal
          itemData={selectedData}
          setToggleUsersDetails={setToggleUsersDetails}
          toggleUsersDetails={toggleUsersDetails}
        />
      )}
    </>
  );
};

export default Users;